import React from 'react';
import {Redirect, withAuthentication} from '../../js/components/Routes';
import {useAppContext} from '../../js/hooks';

const UserPage = withAuthentication(() => {
  const {currentUser} = useAppContext();
  return <Redirect to={`/users/${currentUser.uuid}`} />;
});

export default UserPage;
